export default "__VITE_ASSET__D8AaHy6A__"